/**
 * Tells the server's `event: error` frame apart from EventSource's own `error`.
 *
 * The assistant stream names its failure event `error`, which is also the name
 * EventSource uses for a transport problem (a dropped socket, a non-2xx
 * response, a reconnect attempt). Both arrive at the same `"error"` listener:
 *
 * - the server's frame is a `MessageEvent` carrying the JSON envelope in `data`;
 * - a transport error is a plain `Event` with no `data` at all.
 *
 * Getting this wrong either leaves the reply on "Thinking…" (a server error
 * treated as a dropped connection) or JSON-parses `undefined`. Import-free, so
 * `node --test` can load it directly.
 */

export type SseErrorClassification = { kind: "server"; data: string } | { kind: "transport" };

/** Classify one event delivered to an EventSource `"error"` listener. */
export function classifySseErrorEvent(event: Event): SseErrorClassification {
  // `MessageEvent` is a global in browsers and in Node 22+, but guard anyway so
  // an environment without it never throws here.
  if (
    typeof MessageEvent !== "undefined" &&
    event instanceof MessageEvent &&
    typeof event.data === "string" &&
    event.data !== ""
  ) {
    return { kind: "server", data: event.data };
  }
  return { kind: "transport" };
}
